module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Email Details")]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted justify-content-center"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.All_Email_Data_List_data,
      "responsive": "",
      "fields": _vm.Columns,
      "primary-key": "common_over_id",
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "mail_id",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                    " + _vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage) + "\n                  ")])]
      }
    }, {
      key: "type",
      fn: function(row9) {
        return [(
          row9.item.agentName != '' &&
          row9.item.agentName != null
        ) ? _c('b-button', {
          staticStyle: {
            "margin-left": "2px",
            "margin-bottom": "2px",
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.ShowMailData(row9.item, 'agentName', row9.item.type + ' List')
            }
          }
        }, [_vm._v(_vm._s(row9.item.type))]) : _c('span', [_vm._v("--")])]
      }
    }, {
      key: "mail_subject",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.mail_subject != "" ? row1.item.mail_subject : "--"))])]
      }
    }, {
      key: "mail_mailbody",
      fn: function(row2) {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(row2.item.mail_mailbody)
          }
        }, [_vm._v(_vm._s(row2.item.mail_mailbody))])]
      }
    }, {
      key: "All_CC",
      fn: function(row3) {
        return [(row3.item.mail_to != '') ? _c('b-button', {
          staticStyle: {
            "margin-left": "2px",
            "margin-bottom": "2px",
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.ShowMailData(row3.item, 'mail_to', 'Mail TO Email List')
            }
          }
        }, [_vm._v("TO")]) : _vm._e(), _vm._v(" "), (row3.item.mail_cc != '') ? _c('b-button', {
          staticStyle: {
            "margin-left": "2px",
            "margin-bottom": "2px",
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.ShowMailData(row3.item, 'mail_cc', 'Mail CC Email List')
            }
          }
        }, [_vm._v("CC")]) : _vm._e(), _vm._v(" "), (row3.item.mail_bcc != '') ? _c('b-button', {
          staticStyle: {
            "margin-left": "2px",
            "margin-bottom": "2px",
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.ShowMailData(row3.item, 'mail_bcc', 'Mail BCC Email List')
            }
          }
        }, [_vm._v("BCC")]) : _vm._e(), _vm._v(" "), (
          row3.item.mail_previousto != '' &&
          row3.item.mail_previousto != null
        ) ? _c('b-button', {
          staticStyle: {
            "margin-left": "2px",
            "margin-bottom": "2px",
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.ShowMailData(row3.item, 'mail_previousto', 'Mail Previous TO Email List')
            }
          }
        }, [_vm._v("Previous To")]) : _vm._e(), _vm._v(" "), (
          row3.item.mail_previouscc != '' &&
          row3.item.mail_previouscc != null
        ) ? _c('b-button', {
          staticStyle: {
            "margin-left": "2px",
            "margin-bottom": "2px",
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.ShowMailData(row3.item, 'mail_previouscc', 'Mail Previous CC Email List')
            }
          }
        }, [_vm._v("Previous CC")]) : _vm._e(), _vm._v(" "), (
          row3.item.mail_previousbcc != '' &&
          row3.item.mail_previousbcc != null
        ) ? _c('b-button', {
          staticStyle: {
            "margin-left": "2px",
            "margin-bottom": "2px",
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.ShowMailData(row3.item, 'mail_previousbcc', 'Mail Previous BCC Email List')
            }
          }
        }, [_vm._v("Previous BCC")]) : _vm._e()]
      }
    }, {
      key: "MailStatus",
      fn: function(row22) {
        return [_c('h6', [(row22.item.is_email_send == '1') ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(_vm._s(row22.item.MailStatus))]) : _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(_vm._s(row22.item.MailStatus))])], 1)]
      }
    }, {
      key: "username",
      fn: function(row24) {
        return [_c('span', [_vm._v(_vm._s(row24.item.username))])]
      }
    }, {
      key: "mail_doc",
      fn: function(row5) {
        return _vm._l((row5.item.mail_doc.split(',')), function(mail_doc, doc_index) {
          return _c('span', {
            key: doc_index
          }, [(mail_doc != '') ? _c('b-button', {
            staticStyle: {
              "margin-left": "2px",
              "margin-bottom": "2px",
              "font-size": "0.675rem"
            },
            attrs: {
              "size": "sm",
              "variant": "success"
            },
            on: {
              "click": function($event) {
                _vm.PrintEmail_Doc(mail_doc)
              }
            }
          }, [_vm._v("View Doc " + _vm._s(doc_index + 1) + "\n                    ")]) : _vm._e()], 1)
        })
      }
    }, {
      key: "created_at",
      fn: function(row24) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("moment")(row24.item.created_at)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "EmailList-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": 'All ' + _vm.mailDetails.title
    }
  }, [_vm._v("\n    " + _vm._s(_vm.mailDetails[_vm.mailDetails.viewType]) + "\n    "), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    staticClass: "text-center"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideMailData
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0106e8ac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/email-details.vue
// module id = 2350
// module chunks = 0